<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Gate de Saídas</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Nova Saída"
          icon="assets/add.svg"
          (click)="navigateNovaSaida()"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Lista de Saídas no Gate</div>
        <div class="align-button">
          <form
            [formGroup]="form"
            class="table-filters"
            (ngModelChange)="getSaidas()">
            <app-input
              label="N° do Gate Entrada"
              placeholder="Digite aqui"
              name="CD_GATE_ENTR"
              formControlName="CD_GATE_ENTR"
              width="100%"></app-input>
            <app-input
              label="ID Empresa"
              placeholder="Digite aqui"
              name="CD_EPSA"
              formControlName="CD_EPSA"
              width="100%"></app-input>
            <app-input
              label="Motorista"
              placeholder="Digite aqui"
              name="NM_MTRT"
              formControlName="NM_MTRT"
              width="100%"></app-input>
            <app-input
              label="Placa do Cavalo"
              mask="AAA-0A00"
              placeholder="Digite aqui"
              name="TX_PLCA_CAVA"
              formControlName="TX_PLCA_CAVA"
              width="100%"></app-input>
            <span></span>
            <span></span>
            <app-input
              type="datetime-local"
              label="Data Início"
              placeholder="Digite aqui"
              name="DT_INIC"
              formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input
              type="datetime-local"
              label="Data Final"
              placeholder="Digite aqui"
              name="DT_FIM"
              formControlName="DT_FIM"
              width="100%"></app-input>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>

  <div class="mobile">
    <form
      [formGroup]="form"
      (ngModelChange)="getSaidas()"
      class="table-filters">
      <app-input
        label="N° do Gate Entrada"
        placeholder="Digite aqui"
        name="CD_GATE_ENTR"
        formControlName="CD_GATE_ENTR"
        width="100%"></app-input>
      <app-input
        label="ID Empresa"
        placeholder="Digite aqui"
        name="CD_EPSA"
        formControlName="CD_EPSA"
        width="100%"></app-input>
      <app-input
        label="Motorista"
        placeholder="Digite aqui"
        name="NM_MTRT"
        formControlName="NM_MTRT"
        width="100%"></app-input>
      <app-input
        label="Placa do Cavalo"
        placeholder="Digite aqui"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_INIC"
        formControlName="DT_INIC"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data Final"
        placeholder="Digite aqui"
        name="DT_FIM"
        formControlName="DT_FIM"
        width="100%"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
